import {
  Box,
  HStack,
  Heading,
  IconButton,
  Stack,
  Text,
  Link,
  useBreakpointValue,
} from "@chakra-ui/react";
import { EventDetailDescriptionSection } from "@common/interfaces/KYDEvent";
import { FiEdit2 } from "react-icons/fi";
import Markdown from "react-markdown";
import { SectionProps } from "../sections/sectionsComponents";
import { EditModalType, markdownToLineBreaks } from "../../../utils";
import EditDescriptionModal from "./EditDescriptionModal";
import ShowIfHasPermission from "../../ShowIfHasPermission";

const EventDescription = ({
  data,
  isLoading,
  setModalType,
  onUpdateEvent,
  permissions,
  modalType,
}: SectionProps<EventDetailDescriptionSection["data"]>) => {
  const isMobile = useBreakpointValue({
    base: true,
    md: false,
  });
  const internalDescription = markdownToLineBreaks(data?.description);

  return (
    <Stack spacing={2}>
      <EditDescriptionModal
        isOpen={modalType === EditModalType.DESCRIPTION}
        isLoading={isLoading}
        onSave={(values) => {
          onUpdateEvent("description", values.description);
        }}
        setModalType={setModalType}
        data={data}
      />
      <HStack>
        <Text fontWeight={"bold"}>Description</Text>
        <ShowIfHasPermission permissions={permissions} checkFor="write">
          <IconButton
            isDisabled={isLoading}
            onClick={() => setModalType(EditModalType.DESCRIPTION)}
            icon={<FiEdit2 fontSize="1.25rem" />}
            variant="ghost"
            aria-label="Edit member"
          />
        </ShowIfHasPermission>
      </HStack>
      {data?.description ? (
        <Box
          borderWidth={"1px"}
          borderColor="gray.200"
          borderRadius={"lg"}
          p={4}
        >
          {internalDescription ? (
            <Markdown
              className="mdx-editor"
              components={{
                a: (props) => (
                  <Link
                    href={props.href}
                    target={"_blank"}
                    textDecoration={"underline"}
                    color={isMobile ? "blue.200" : "blue.800"}
                  >
                    {props.children}
                  </Link>
                ),
                h1: (props) => <Heading {...props} fontSize={24} />,
                h2: (props) => <Heading {...props} fontSize={22} />,
                h3: (props) => <Heading {...props} fontSize={20} />,
                h4: (props) => <Heading {...props} fontSize={18} />,
                h5: (props) => <Heading {...props} fontSize={16} />,
                p: (props) => <Text {...props}>{props.children}</Text>,
              }}
            >
              {internalDescription}
            </Markdown>
          ) : null}
        </Box>
      ) : (
        <Text color="gray.500">No description added yet</Text>
      )}
    </Stack>
  );
};

export default EventDescription;
